import React, { useEffect, useState, useCallback, useMemo } from 'react';
import StatusTag from '../StatusTag';
import {
  Box,
  Button,
  Flex,
  Menu,
  Tooltip,
  Text,
  Loader,
  Select,
  Alert,
  Modal,
  Drawer
} from '@mantine/core';
import { IoSaveOutline } from 'react-icons/io5';
import { RxCountdownTimer } from 'react-icons/rx';
import { VscGitPullRequest } from 'react-icons/vsc';
import { LuInfo } from 'react-icons/lu';
import { SearchDropdown } from '../SearchDropdown';
import { SavedTemplates } from '../SavedTemplatesModal';
import { FileSelect } from '../FileSelect';
import ErrorBoundary from '../../../../components/ErrorBoundary';
import { notifications } from '@mantine/notifications';
import { TbArrowRight, TbCheck, TbChevronDown, TbInfoCircle, TbLine } from 'react-icons/tb';
import extractionStore from '../../store';
import transformationStore from '../../transformation.store';
import { observer } from 'mobx-react-lite';
import { REPORT_TYPES } from '../../../../consts/reportTypes';
import { BiPlus } from 'react-icons/bi';
// import Drawer from '../../../../components/Drawer';

import AddDataCategory from '../AddDataCategory';
import {
  useCreateCustomCategory,
  useDeleteCustomCategory
} from '../../../../services/workflow.services';
import { extractApiError } from '../../../../utils';
import toast from 'react-hot-toast';
import { BsTrash } from 'react-icons/bs';
import { permissionPolicies } from '../../../../permissions/policies';
import { PermissionGuard, DENY_REASONS } from '../../../../components/PermissionGuard';
import { idCreator } from '../../../Project/utils/idCreator';

const extractionTypes = [
  {
    name: 'AI Extraction',
    id: 'Automatic',
    description: 'AI automatically identifies, extracts, and maps data with minimal user input.'
  },
  {
    name: 'Clone Extraction',
    id: 'SemiAutomatic',
    description: 'Apply existing extraction knowledge and review or adjust results as needed.'
  },
  {
    name: 'Manual Extraction',
    id: 'Manual',
    description: 'Select and map data yourself for full control over the extraction process.'
  }
];

const statusIcon = {
  completed: <TbCheck color="#2F9E44" fontSize="20px" style={{ minWidth: '20px' }} />,
  'in progress': <Loader color="blue" size="xs" />,
  failed: (
    <Tooltip
      p="8px"
      fz="12px"
      bg="gray.6"
      lh="18px"
      position="right-start"
      label="Extraction failed, please try again."
    >
      <Flex>
        <TbInfoCircle color="#FA5252" fontSize="20px" style={{ minWidth: '20px' }} />
      </Flex>
    </Tooltip>
  )
};

const Header = ({
  onSave,
  isLoadingButton,
  isHasTemplates,
  activeTab,
  status,
  isLoadingCancel,
  onCanceAutoExtract,
  toggleFundMapping,
  categories,
  category,
  disabledLookupCategory,
  onChangeCategory,
  files,
  onSelectFile,
  onSelectSheet,
  sheet,
  file,
  onChangeAction,
  hasSemiExtraction,
  onOpenSemiExtract,
  onExtractSelectedFields,
  extractedFile,
  savedFiles,
  onActionDelete,
  onEdit,
  onOpenTemplates,
  openTemplates,
  onCancelAutoExtract,
  extractionResults,
  canUndo,
  onSelectExtractCategory,
  extractId,
  funds,
  reportType,
  extractFile,
  refetchCategories,
  extractedTransformationTable,
  onChangeExtractedTransformationTable,
  isLoadingFiles,
  workflowId,
  periodId,
  currentUser,
  project
}) => {
  const [openCategoryAddDrawer, setOpenCategoryAddDrawer] = useState(false);
  const [selectedDeleteCategory, setSelectedDeleteCategory] = useState(null);
  const [templateActiveFiles, setTemplateActiveFiles] = useState([]);
  const [templateWithCategory, setTemplateWithCategory] = useState(false);

  const createCustomCategory = useCreateCustomCategory();
  const deleteCustomCategory = useDeleteCustomCategory();

  const hasPermissionToModify = permissionPolicies.checkAccess({
    currentUserRole: currentUser?.role,
    currentUserId: currentUser?.azure_object_id,
    assignedTo: project?.assigned_to
  });

  const permissionDeniedText = "You don't have permission";

  const handleSelectDeleteCategory = val => e => {
    e.preventDefault();
    e.stopPropagation();

    setSelectedDeleteCategory(val);
  };

  const isCustomReportType = reportType === REPORT_TYPES.CUSTOM;
  const hideFundsMapping = isCustomReportType;

  const { regularCategories, calculatedCategories } = useMemo(() => {
    if (!categories?.length) return { regularCategories: [], calculatedCategories: [] };
    return {
      regularCategories: categories.filter(c => c.type !== 'calculated'),
      calculatedCategories: categories.filter(c => c.type === 'calculated')
    };
  }, [categories]);

  const { isLockedPeriod, selectedExtractItems, setExtractionType, extractionType } =
    extractionStore;
  const { tableNames, setTableNames } = transformationStore;

  // Refactored heavy inline event handlers
  const handleCancelAutoExtract = useCallback(() => {
    onCancelAutoExtract({
      id: status.id,
      type: 'cancel-auto-extraction'
    });
  }, [onCancelAutoExtract, status?.id]);

  const handleCancelExtract = useCallback(() => {
    onCancelAutoExtract({
      type: 'cancel-auto-extraction',
      id: status.id
    });
  }, [onCancelAutoExtract, status?.id]);

  const onChangeExtractType = async item => {
    onChangeAction(item.id);
    setExtractionType(item);
  };

  const handleSelectCategory = catgry => {
    if (catgry === extractId || !catgry) return;

    onSelectExtractCategory(catgry);
    onChangeExtractedTransformationTable('');
  };

  const onChangeDataCategory = item => {
    if (disabledLookupCategory && item.name === 'Lookup') {
      notifications.show({
        title: 'In order to use Lookup category, the fund mappings must be removed.',
        position: 'bottom-center',
        withCloseButton: true,
        color: 'orange',
        icon: (
          <Flex
            miw="24px"
            h="24px"
            sx={() => ({
              borderRadius: '50%'
            })}
            justify="center"
            align="center"
            bg="#FD7E14"
          >
            <TbInfoCircle fontSize="16px" color="#fff" />
          </Flex>
        )
      });
      return;
    }
    onChangeCategory(item);
  };

  const onAddNewCategory = vals => {
    const _vals = { ...vals };
    const isFund = vals.is_fund === 'asset';

    delete _vals.is_fund;

    createCustomCategory.mutate(
      {
        isFund: isFund,
        data: { ..._vals },
        workflowId: workflowId,
        periodId
      },
      {
        onSuccess: res => {
          toast.success('New Data Category successfully added!');
          refetchCategories();
          setOpenCategoryAddDrawer(false);
          onChangeDataCategory(res);
        },
        onError: err => {
          toast.error(extractApiError(err, 'Unable to create this data category.'));
        }
      }
    );
  };

  const handleDeleteCustomCategory = id => {
    deleteCustomCategory.mutate(id, {
      onSuccess: () => {
        toast.success('Successfully deleted');
        setSelectedDeleteCategory(null);
        onChangeDataCategory(null);
        refetchCategories();
      },
      onError: err => {
        toast.error(extractApiError(err, 'Unable to delete this data category.'));
      }
    });
  };

  useEffect(() => {
    if (activeTab !== 'transformation' || !tableNames || tableNames?.length === 0) return;
    if (tableNames.includes(extractedTransformationTable)) return;

    const firstTable = tableNames[0];

    onChangeExtractedTransformationTable(firstTable);
  }, [activeTab, tableNames, extractedTransformationTable]);

  useEffect(() => {
    return () => {
      // NOTE: previously this cleanup also called
      //   onChangeExtractedTransformationTable('')
      // to clear the URL param on Header unmount. That writeback went
      // through `setExtractedTransformationTable` in DataExtraction, which
      // uses react-router's `setSearchParams`. The setSearchParams reference
      // captured in this Header's render closure carries that render's
      // searchParams snapshot — so calling it on unmount (after the parent
      // has navigated to a different tab) wrote the OLD tab back into the
      // URL and bounced the user. The `extractedTransformationTable` param
      // is only read on the transformation tab, so leaving it set when
      // unmounting is functionally a no-op for other tabs.
      setTableNames([]);
    };
  }, []);

  const renderCategoryOption = item => (
    <Menu.Item
      id={`data-extraction-header-category-option-${idCreator(item.name)}`}
      onClick={() => onChangeDataCategory(item)}
      key={item.name}
      w="100%"
      opacity={deleteCustomCategory.isLoading && 0.5}
      sx={{ pointerEvents: deleteCustomCategory.isLoading && 'none' }}
    >
      <Flex align="center" justify="space-between">
        <Tooltip label={item.name} disabled={!item.name}>
          <Flex align="center" gap="4px">
            <Text
              id={`data-extraction-header-category-option-name-${idCreator(item.name)}`}
              fz="14px"
              lh="20px"
              lineClamp={2}
            >
              {item.name}
            </Text>
            {item.question && (
              <Text
                id={`data-extraction-header-category-option-question-${idCreator(item.name)}`}
                fz="10px"
                c="dimmed"
                style={{ whiteSpace: 'nowrap' }}
              >
                (Q{item.question})
              </Text>
            )}
          </Flex>
        </Tooltip>

        <Flex align="center" gap="6px">
          {!!extractionResults.categories[item.name] &&
            statusIcon[extractionResults.categories[item.name]]}
          {disabledLookupCategory && item.name === 'Lookup' ? (
            <Tooltip
              maw="220px"
              multiline
              p="8px"
              fz="12px"
              bg="gray.6"
              lh="18px"
              position="right-start"
              zIndex={100001}
              label="In order to use Lookup category, the fund mappings must be removed."
            >
              <Flex miw="16px">
                <TbInfoCircle color="#FD7E14" fontSize="16px" />
              </Flex>
            </Tooltip>
          ) : (
            !!item.description && (
              <Tooltip
                maw="220px"
                multiline
                p="8px"
                fz="12px"
                bg="gray.6"
                lh="18px"
                position="right-start"
                zIndex={100001}
                label={item.description}
              >
                <Flex miw="16px">
                  <TbInfoCircle color="#228BE6" fontSize="16px" />
                </Flex>
              </Tooltip>
            )
          )}

          {isCustomReportType && (
            <Button
              id={`data-extraction-header-category-option-delete-${idCreator(item.name)}`}
              size="xs"
              variant="transparent"
              onClick={handleSelectDeleteCategory(item)}
              pr={0}
            >
              <BsTrash color="#ADB5BD" />
            </Button>
          )}
        </Flex>
      </Flex>
    </Menu.Item>
  );

  const noExtractionFound = useMemo(() => {
    if (!extractionResults?.sheets || extractionResults?.sheets?.length === 0) return false;
    if (!sheet) return false;
    return !extractionResults.sheets[sheet.id];
  }, [extractionResults?.sheets, sheet]);

  return (
    <ErrorBoundary componentName="DataExtractionHeader">
      <Box
        id="data-extraction-header-root"
        p="16px"
        bg="#fff"
        sx={() => ({
          borderRadius: '4px'
        })}
      >
        {status?.status && activeTab === 'extraction' && status?.status !== 'cancelled' && (
          <StatusTag
            idPrefix="data-extraction-header-status"
            onCanceAutoExtract={handleCancelAutoExtract}
            errorMessage={status.error_message}
            isLoadingCancel={isLoadingCancel}
            status={status.status}
          />
        )}

        <Flex id="data-extraction-header-top-row" align="center" justify="flex-end">
          {activeTab !== 'lookup_tables' && (
            <Flex id="data-extraction-header-actions" align="center" gap="16px">
              {activeTab === 'extraction' && !isLockedPeriod && (
                <PermissionGuard allowed={hasPermissionToModify}>
                  <Button
                    id="data-extraction-header-save-extraction"
                    disabled={isLoadingButton || !canUndo}
                    onClick={onSave}
                    isLoading={isLoadingButton}
                    variant="subtle"
                    size="sm"
                    leftSection={<IoSaveOutline />}
                  >
                    Save Extraction
                  </Button>
                </PermissionGuard>
              )}

              {!isLockedPeriod && (
                <Menu
                  id="data-extraction-header-templates-menu"
                  shadow="md"
                  opened={openTemplates}
                  onClose={onOpenTemplates}
                  width={351}
                  closeOnItemClick={false}
                >
                  <Menu.Target>
                    <Tooltip label="Access your previously completed data extractions.">
                      <Button
                        id="data-extraction-header-completed-extractions"
                        disabled={!isHasTemplates}
                        onClick={onOpenTemplates}
                        variant="subtle"
                        size="sm"
                        leftSection={<RxCountdownTimer />}
                      >
                        Completed Extractions
                      </Button>
                    </Tooltip>
                  </Menu.Target>
                  <Menu.Dropdown maw="394px" miw="394px">
                    <SavedTemplates
                      idPrefix="data-extraction-header-saved-templates"
                      savedFiles={savedFiles}
                      onActionDelete={onActionDelete}
                      onEdit={onEdit}
                      onClose={onOpenTemplates}
                      hasMutateMode={!isLockedPeriod}
                      hasPermissionToModify={hasPermissionToModify}
                      activeFiles={templateActiveFiles}
                      setActiveFiles={setTemplateActiveFiles}
                      withCategory={templateWithCategory}
                      setWithCategory={setTemplateWithCategory}
                    />
                  </Menu.Dropdown>
                </Menu>
              )}
            </Flex>
          )}
        </Flex>

        {activeTab !== 'lookup_tables' && (
          <Flex
            id="data-extraction-header-main-row"
            mt="15px"
            align="center"
            justify="space-between"
          >
            <Flex
              id="data-extraction-header-inputs"
              align="flex-end"
              justify="space-between"
              gap="8px"
            >
              <FileSelect
                idPrefix="data-extraction-header-file"
                label="Input Document"
                options={files}
                placeholder="Select document"
                value={file}
                onChange={onSelectFile}
                hasSearch
                isLoading={isLoadingFiles}
              />
              <Flex
                id="data-extraction-header-divider-file-sheet"
                align="center"
                h="24px"
                justify="center"
              >
                <TbLine size={20} color="#DEE2E6" rotate={1} className="rotated-icon" />
              </Flex>
              <SearchDropdown
                idPrefix="data-extraction-header-sheet"
                label={file?.format === 'pdf' ? 'Pages' : 'Input Sheet'}
                options={file?.sheets || []}
                placeholder="Select sheet"
                value={sheet}
                onChange={onSelectSheet}
                statuses={file?.format === 'pdf' ? {} : extractionResults.sheets}
                hasSearch
                isLoading={isLoadingFiles}
                sortByStatus
              />

              {activeTab !== 'transformation' && (
                <>
                  <Flex
                    id="data-extraction-header-divider-sheet-category"
                    align="center"
                    h="24px"
                    justify="center"
                  >
                    <TbArrowRight fontSize="20px" color="#DEE2E6" />
                  </Flex>

                  <SearchDropdown
                    idPrefix="data-extraction-header-category"
                    value={category}
                    label="Data Category"
                    options={regularCategories}
                    placeholder="Select Data Category"
                    onChange={onChangeCategory}
                    disabledOptions={disabledLookupCategory ? ['Lookup'] : []}
                    statuses={extractionResults.categories}
                    dropdownFooter={
                      isCustomReportType && (
                        <Button
                          id="data-extraction-header-add-data-category"
                          w="100%"
                          opacity={deleteCustomCategory.isLoading && 0.5}
                          sx={{ pointerEvents: deleteCustomCategory.isLoading && 'none' }}
                        >
                          Add Data Category
                        </Button>
                      )
                    }
                    hasSearch={categories?.length > 0}
                    renderOptions={renderCategoryOption}
                    subMenuGroup={
                      calculatedCategories.length > 0
                        ? {
                            label: 'Direct answers',
                            items: calculatedCategories,
                            renderItem: renderCategoryOption
                          }
                        : null
                    }
                    isLoading={isLoadingFiles}
                  />
                </>
              )}

              {activeTab !== 'transformation' && (
                <>
                  <Flex
                    id="data-extraction-header-divider-category-extraction"
                    align="center"
                    h="24px"
                    justify="center"
                  >
                    <TbArrowRight fontSize="20px" color="#DEE2E6" />
                  </Flex>
                  <PermissionGuard
                    allowed={!isLockedPeriod && hasPermissionToModify}
                    reason={
                      isLockedPeriod ? DENY_REASONS.LOCKED_PERIOD : DENY_REASONS.NO_PERMISSION
                    }
                  >
                    <SearchDropdown
                      idPrefix="data-extraction-header-extraction-type"
                      options={
                        hasSemiExtraction
                          ? extractionTypes
                          : extractionTypes.filter(item => item.id !== 'SemiAutomatic')
                      }
                      hasInfoIcon
                      placeholder="Start extraction"
                      value={extractionType}
                      onChange={onChangeExtractType}
                      color="#228be6"
                      renderOptions={item => (
                        <Menu.Item
                          id={`data-extraction-header-extraction-type-option-${item.id}`}
                          onClick={() => onChangeExtractType(item)}
                          key={item.id}
                          w="100%"
                        >
                          <Flex
                            id={`data-extraction-header-extraction-type-row-${item.id}`}
                            align="center"
                            justify="space-between"
                          >
                            <Tooltip label={item.name} disabled={!item.name}>
                              <Text
                                id={`data-extraction-header-extraction-type-name-${item.id}`}
                                fz="14px"
                                lh="20px"
                                lineClamp={2}
                              >
                                {item.name}
                              </Text>
                            </Tooltip>

                            {!!item.description && (
                              <Tooltip
                                maw="260px"
                                multiline
                                p="8px"
                                fz="12px"
                                bg="gray.6"
                                lh="18px"
                                position="right-start"
                                zIndex={100001}
                                label={item.description}
                              >
                                <Flex miw="16px">
                                  <TbInfoCircle fontSize="16px" color="#228BE6" />
                                </Flex>
                              </Tooltip>
                            )}
                          </Flex>
                        </Menu.Item>
                      )}
                    />
                  </PermissionGuard>

                  {!isLockedPeriod && status?.status === 'in progress' && (
                    <PermissionGuard allowed={hasPermissionToModify}>
                      <Button
                        id="data-extraction-header-cancel-extraction"
                        mt="23px"
                        size="xs"
                        onClick={handleCancelExtract}
                        h="26px"
                        fz="12px"
                        fw="400"
                        color="red"
                      >
                        Cancel Extraction
                      </Button>
                    </PermissionGuard>
                  )}

                  {!isLockedPeriod &&
                    extractionType &&
                    status?.status !== 'in progress' &&
                    extractionType.id === 'Automatic' && (
                      <PermissionGuard allowed={hasPermissionToModify}>
                        <Button
                          id="data-extraction-header-extract-selected"
                          disabled={
                            !file ||
                            !sheet ||
                            !category ||
                            !extractionType ||
                            selectedExtractItems.length === 0
                          }
                          mt="23px"
                          size="xs"
                          onClick={onExtractSelectedFields}
                          h="26px"
                          fz="12px"
                          fw="400"
                        >
                          {extractedFile
                            ? `Re-Extract ${selectedExtractItems.length > 0 ? `(${selectedExtractItems.length})` : ''}`
                            : `Extract ${selectedExtractItems.length > 0 ? `(${selectedExtractItems.length})` : ''}`}
                        </Button>
                      </PermissionGuard>
                    )}
                </>
              )}

              {/* {!isLockedPeriod && activeTab === 'transformation' && !noExtractionFound && ( */}
              {!isLockedPeriod && activeTab === 'transformation' && (
                <>
                  <Flex
                    id="data-extraction-header-divider-extraction-type"
                    align="center"
                    h="24px"
                    justify="center"
                  >
                    <TbArrowRight fontSize="20px" color="#DEE2E6" />
                  </Flex>

                  <Select
                    id="data-extraction-header-extracted-category"
                    data={extractFile?.map(item => ({
                      label: item.category,
                      value: item.id
                    }))}
                    value={extractId}
                    rightSection={<TbChevronDown size={12} />}
                    onChange={handleSelectCategory}
                    placeholder="Select"
                    label="Extracted Category"
                    size="xs"
                    styles={{
                      input: {
                        height: '24px',
                        minHeight: '24px'
                      }
                    }}
                  />

                  <Flex
                    id="data-extraction-header-divider-extracted-category-table"
                    align="center"
                    h="24px"
                    justify="center"
                  >
                    <TbLine size={20} color="#DEE2E6" rotate={1} className="rotated-icon" />
                  </Flex>

                  <Select
                    id="data-extraction-header-extracted-table"
                    data={
                      extractId
                        ? tableNames?.map(item => ({
                            label: item,
                            value: item
                          }))
                        : []
                    }
                    value={extractedTransformationTable || null}
                    rightSection={<TbChevronDown size={12} />}
                    onChange={onChangeExtractedTransformationTable}
                    placeholder="Select"
                    label="Extracted Table"
                    size="xs"
                    styles={{
                      input: {
                        height: '24px',
                        minHeight: '24px'
                      }
                    }}
                  />
                </>
              )}

              {!isLockedPeriod &&
                activeTab === 'transformation' &&
                noExtractionFound &&
                !isCustomReportType && (
                  <>
                    <Flex
                      id="data-extraction-header-divider-transformation-warning"
                      align="center"
                      h="24px"
                      justify="center"
                    >
                      <TbArrowRight fontSize="20px" color="#DEE2E6" />
                    </Flex>

                    <Alert
                      id="data-extraction-header-no-extraction-alert"
                      color="red"
                      variant="light"
                      px="8px"
                      py="1px"
                      fz="10px"
                      icon={<TbInfoCircle size={16} />}
                      title="No extraction found for the selected sheet."
                      styles={{
                        icon: {
                          marginRight: '2px'
                        }
                      }}
                    />
                  </>
                )}
            </Flex>

            <Flex id="data-extraction-header-funds-action">
              {activeTab === 'extraction' && !hideFundsMapping && (
                <PermissionGuard allowed={hasPermissionToModify}>
                  <Button
                    id="data-extraction-header-match-sheet-funds"
                    leftSection={<VscGitPullRequest />}
                    onClick={toggleFundMapping}
                    variant="subtle"
                    size="sm"
                    mt="23px"
                    rightSection={
                      <Tooltip
                        label={`Not all funds are matched. Click "Match Sheet Funds" to complete the matching process.`}
                      >
                        <Flex>
                          <LuInfo color="#FD7E14" />
                        </Flex>
                      </Tooltip>
                    }
                  >
                    Match Sheet Funds
                  </Button>
                </PermissionGuard>
              )}
            </Flex>
          </Flex>
        )}
        <Drawer
          id="data-extraction-header-add-category-drawer"
          opened={openCategoryAddDrawer}
          withCloseButton
          position="left"
          title="Add Data Category"
          withOverlay={false}
          onClose={() => setOpenCategoryAddDrawer(false)}
          style={{
            width: '430px'
          }}
        >
          <AddDataCategory
            onClose={() => setOpenCategoryAddDrawer(false)}
            onSubmit={onAddNewCategory}
            isSubmitting={createCustomCategory.isLoading}
          />
        </Drawer>

        <Modal
          id="data-extraction-header-delete-category-modal"
          opened={!!selectedDeleteCategory}
          radius="sm"
          withCloseButton
          withinPortal
          onClose={() => setSelectedDeleteCategory(null)}
          centered
          title={`Delete ${selectedDeleteCategory?.name} Category?`}
          size="sm"
          zIndex={99999}
        >
          <Box>
            <Text c="gray.7" fz="sm" mb="24">
              Are you sure want to delete Data Category?
            </Text>
            <Flex align="center" gap="16" justify="flex-end">
              <Button
                id="data-extraction-header-delete-category-cancel"
                onClick={() => setSelectedDeleteCategory(null)}
                variant="default"
              >
                Cancel
              </Button>
              <Button
                id="data-extraction-header-delete-category-confirm"
                color="red.8"
                loading={deleteCustomCategory.isLoading}
                disabled={deleteCustomCategory.isLoading}
                onClick={() => handleDeleteCustomCategory(selectedDeleteCategory?.id)}
              >
                Yes, Delete
              </Button>
            </Flex>
          </Box>
        </Modal>
      </Box>
    </ErrorBoundary>
  );
};

export default observer(Header);
